import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Countries';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of country',
	breadcrumbs: [
		{
			title: title,
			link: '/hydrodrip/countries',
		},
	],
};

export default function EditCountry() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[data, setData] = useState({}),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		{ id } = useParams();

	async function onGet() {
		setLoading(true);
		let res = await resources.country
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			setData(res.data);
		} else if (res.status === 403) {
			setFail(true);
		}

		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, [id]);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onUpdate(e) {
		e.preventDefault();
		setLoader(true);
		setErrors({});
		let formData = new FormData(e.target);
		if (!formData.get('password')) {
			formData.delete('password');
		}
		let object = {};
		formData.forEach((value, key) => (object[key] = value));

		let res = await resources.country
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/hydrodrip/countries');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onUpdate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<Field
									name="name"
									className="mb-3"
									error={errors['name']}
									defaultValue={data?.name}
									required
								>
									Country name
								</Field>

								<Field
									name="code_1"
									type="number"
									className="mb-3"
									error={errors['code_1']}
									defaultValue={data?.code_1}
									required
								>
									Country code 1
								</Field>

								<Field
									name="code_2"
									className="mb-3"
									error={errors['code_2']}
									defaultValue={data?.code_2}
									required
								>
									Country code 2
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
									defaultValue={data?.description}
								>
									Description
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary "
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
